module.exports = "/virtual-football-league/img/amblems/left/logos/Atm.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Atm.png
// module id = 2053
// module chunks = 4